module.exports = __webpack_public_path__ + "img/0.927cf882.png";